import { callAPI, apiURL } from './api'

const getTaxRules = (context) => callAPI(context, `/tax-rules`, 'GET')

export default {
  getTaxRules
}
